import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

const DEMO_USERS = [
  {
    email: 'superadmin@webpages123.com',
    password: 'Admin@123',
    metadata: {
      full_name: 'Super Admin',
      first_name: 'Super',
      last_name: 'Admin',
      role: 'super_admin',
    },
  },
  {
    email: 'admin@webpages123.com',
    password: 'Admin@123',
    metadata: {
      full_name: 'Sarah Mitchell',
      first_name: 'Sarah',
      last_name: 'Mitchell',
      role: 'admin',
    },
  },
  {
    email: 'editor@webpages123.com',
    password: 'Editor@123',
    metadata: {
      full_name: 'Michael Chen',
      first_name: 'Michael',
      last_name: 'Chen',
      role: 'editor',
    },
  },
];

// Bump version key to force re-run and pick up the new emails
const SETUP_KEY = 'contentcraft_demo_setup_v3';

export const useDemoSetup = () => {
  const [setupStatus, setSetupStatus] = useState('idle');
  const [setupMessage, setSetupMessage] = useState('');

  useEffect(() => {
    const alreadySetup = localStorage.getItem(SETUP_KEY);
    if (alreadySetup === 'done') {
      setSetupStatus('done');
      return;
    }
    runSetup();
  }, []);

  const runSetup = async () => {
    setSetupStatus('running');
    setSetupMessage('Setting up demo accounts...');

    try {
      for (const demoUser of DEMO_USERS) {
        const { data, error: signUpError } = await supabase?.auth?.signUp({
          email: demoUser?.email,
          password: demoUser?.password,
          options: {
            data: demoUser?.metadata,
          },
        });

        if (signUpError) {
          console.warn(`Demo setup: ${demoUser?.email} - ${signUpError?.message}`);
          continue;
        }

        if (data?.user) {
          await supabase?.from('user_profiles')?.upsert(
            {
              id: data?.user?.id,
              email: demoUser?.email,
              full_name: demoUser?.metadata?.full_name,
              first_name: demoUser?.metadata?.first_name,
              last_name: demoUser?.metadata?.last_name,
              role: demoUser?.metadata?.role,
              is_active: true,
            },
            { onConflict: 'id' }
          );

          await supabase?.auth?.signOut();
        }
      }

      localStorage.setItem(SETUP_KEY, 'done');
      setSetupStatus('done');
      setSetupMessage('Demo accounts ready.');
    } catch (err) {
      console.error('Demo setup error:', err);
      setSetupStatus('error');
      setSetupMessage('Setup encountered an issue. You can still try logging in.');
    }
  };

  return { setupStatus, setupMessage };
};
